export const formatLink = (url: string): string => {
  if (!url) return "";
  // check beforehand
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  // if not, add https
  return `https://${url}`;
};
